var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71019 11.1713C7.9155 11.0379 9.29531 10.1925 10.6397 9.369C11.6089 8.77612 11.6089 8.77612 11.592 8.71819C11.5751 8.64787 5.57325 5.00062 5.51194 4.96406C5.39793 4.89673 5.28504 4.82754 5.17331 4.7565C5.28356 4.68 5.49787 4.53375 5.75437 4.35938L6.37875 3.9375L6.80738 4.194C7.33613 4.51012 13.1411 8.07075 13.9545 8.57756C13.6226 8.77725 12.447 9.47306 10.8664 10.404L7.72594 12.2546C7.72021 12.0908 7.71646 11.9269 7.71469 11.763C7.71114 11.566 7.70983 11.3689 7.71075 11.1718L7.71019 11.1713ZM6.37819 7.62975C6.48225 7.69163 6.66225 7.80019 6.88387 7.938L7.46269 8.29688L7.47506 9.3825C7.51162 12.5196 7.51163 12.5196 7.55719 12.5516L7.58756 12.5724L7.62131 12.5601C7.63819 12.555 7.64438 12.5527 13.7362 8.95894L14.0625 8.76656L13.9551 10.2757L13.9157 10.2983C11.4074 11.739 8.89699 13.1761 6.38438 14.6093C6.38213 14.2161 6.37875 12.8739 6.37819 11.124V7.62975ZM5.0625 13.95L5.07656 4.96856L5.29481 5.09738C5.47031 5.19975 6.65381 5.92144 7.99088 6.73931C8.9483 7.32631 9.90718 7.91093 10.8675 8.49319L11.2697 8.73506L9.93994 9.54844L9.67444 9.39375C9.14189 9.07215 8.61126 8.74739 8.08256 8.4195C7.56703 8.0998 7.04952 7.78329 6.53006 7.47L6.16331 7.25625L6.1605 11.0638C6.15937 12.7817 6.15769 14.2093 6.15656 14.6256C6.048 14.5597 5.86294 14.4456 5.64581 14.3106L5.0625 13.95Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeez);
export default __webpack_public_path__ + "static/media/deez.f5141505fa4cb096672555d158534d54.svg";
export { ForwardRef as ReactComponent };